//TODO: this should use ht.toggle function
ht.declare('.revealDiv', function () {
  var opts = $(this).metadata().revealDivOpts;

  $(opts.targetSelector).attr('style', '');
});
